module.exports = __webpack_public_path__ + "static/media/new-website.1513a8fb.png";